import { Button } from 'components/Common/Button';
import renderIcon, { IconName } from 'helpers/renderIcon';
import * as React from 'react';
require('./style.scss');
const classNames = require('classnames');

export type IRightSideModalSizes = 'small' | 'medium';

interface IProps {
	footer?: JSX.Element;
	children?: any;
	modalClass?: string;
	size?: IRightSideModalSizes;
	header?: JSX.Element;
}

class RightSideModal extends React.Component<IProps, {}> {
	public render() {
		const { children, footer, modalClass, size, header } = this.props;

		const modalSizes = {
			small: '--small',
			medium: '--medium',
		};

		return (
			<div className="right-size-modal-wrapper">
				<div
					className={classNames(
						'right-size-modal-wrapper__modal',
						`right-size-modal-wrapper__modal${modalSizes[size || 'small']}`,
						modalClass,
					)}
				>
					<div className="right-size-modal-wrapper__modal__inner">
						<div className="right-size-modal-wrapper__modal__inner__header">{header}</div>
						<div
							className={classNames('right-size-modal-wrapper__modal__inner__content', {
								'right-size-modal-wrapper__modal__inner__content--no-header': !header,
								'right-size-modal-wrapper__modal__inner__content--no-footer': !footer,
							})}
						>
							{children}
						</div>
						{footer && <div className="right-size-modal-wrapper__modal__inner__footer">{footer}</div>}
					</div>
				</div>
			</div>
		);
	}
}

interface ITitleProps {
	backButtonClick?: () => void;
	closeModalClick?: () => void;
	title?: string | JSX.Element;
}

class RightSideModalTitle extends React.Component<ITitleProps, {}> {
	public render() {
		const { backButtonClick, closeModalClick } = this.props;
		let title = this.props.title;

		if (typeof title == 'string') {
			title = <h2 className="right-side-title__title">{title}</h2>;
		}

		return (
			<div className="right-side-title">
				{backButtonClick &&
					renderIcon('arrow_left_round', undefined, undefined, 'right-side-title__back', backButtonClick)}
				{title}
				{closeModalClick && renderIcon('cancel', 24, 24, 'right-side-title__close', closeModalClick)}
			</div>
		);
	}
}

interface IFooterProps {
	leftButtonClick?: () => void;
	rightButtonClick?: () => void;
	leftButtonText?: string;
	leftButtonMobileText?: string;
	leftButtonCustomClass?: string;
	rightButtonText?: string;
	rightButtonMobileText?: string;
	rightButtonIcon?: IconName;
	rightButtonCustomClass?: string;
	isRightButtonDisabled?: boolean;
	isRightButtonHidden?: boolean;
	buttonsWrapperCustomClass?: string;
	children?: any;
}

class RightSideModalFooter extends React.Component<IFooterProps, {}> {
	public render() {
		const {
			leftButtonClick,
			rightButtonClick,
			leftButtonText,
			rightButtonText,
			isRightButtonDisabled,
			isRightButtonHidden,
			rightButtonIcon,
			rightButtonCustomClass,
			leftButtonMobileText,
			rightButtonMobileText,
			buttonsWrapperCustomClass,
			leftButtonCustomClass,
		} = this.props;
		const children = this.props.children;

		return (
			<div className="right-side-footer">
				{children}
				{/** Row reversed */}
				<div
					className={`right-side-footer__buttonsWrapper ${buttonsWrapperCustomClass ? buttonsWrapperCustomClass : ''}`}
				>
					{!isRightButtonHidden && rightButtonClick && rightButtonText ? (
						<Button
							className={`right-side-footer__rightButton ${rightButtonIcon ? 'withIcon' : ''} ${
								rightButtonCustomClass ? rightButtonCustomClass : ''
							}`}
							onClick={rightButtonClick}
							disabled={isRightButtonDisabled}
						>
							{rightButtonIcon ? renderIcon(rightButtonIcon, 20, 20) : null}
							<span className="right-side-footer__desktopButtonText">{rightButtonText}</span>
							<span className="right-side-footer__mobileButtonText">
								{rightButtonMobileText ? rightButtonMobileText : rightButtonText}
							</span>
						</Button>
					) : null}
					{leftButtonClick && leftButtonText && (
						<div
							className={`right-side-footer__leftButton ${leftButtonCustomClass ? leftButtonCustomClass : ''}`}
							onClick={leftButtonClick}
						>
							<span className="right-side-footer__desktopButtonText">{leftButtonText}</span>
							<span className="right-side-footer__mobileButtonText">
								{leftButtonMobileText ? leftButtonMobileText : leftButtonText}
							</span>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export { RightSideModal, RightSideModalTitle, RightSideModalFooter };
